import { render, staticRenderFns } from "./commonTop.vue?vue&type=template&id=2f91bf98&scoped=true"
import script from "./commonTop.vue?vue&type=script&lang=js"
export * from "./commonTop.vue?vue&type=script&lang=js"
import style0 from "./commonTop.vue?vue&type=style&index=0&id=2f91bf98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f91bf98",
  null
  
)

export default component.exports